<div [class.important]="color.important" class="iot-platform-ui-popup popup {{ data.cssClass }}">
  <div class="popup-header flex flex-row items-center justify-between">
    <h1 class="popup-title">{{ popupInfo().title }}</h1>
    <button (click)="close(false)" mat-icon-button>
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="popup-content flex flex-col" [class.items-center]="data.icon" [class.justify-center]="data.icon">
    @if (data.icon) {
      <span class="popup-message">{{ data.message ?? popupInfo().message | translate }}</span>
      <div class="topic-name flex flex-row">
        <mat-icon [svgIcon]="data.icon" class="icon"></mat-icon>
        <span class="popup-value">{{ popupMessage() | translate }}</span>
      </div>
    } @else if (data.message) {
      <span class="popup-message font-semibold text-gray-700">{{ data.message | translate }}</span>
    } @else {
      <span class="popup-value">{{ popupMessage() | translate }}</span>
      <span class="popup-message">{{ popupInfo().message | translate }}</span>
    }
  </div>

  <div class="popup-footer flex flex-row items-center justify-end">
    @if (data.type === 'error') {
      <button (click)="close(false)" class="popup-close" mat-button>{{ popupInfo().close }}</button>
    } @else {
      <button (click)="close(false)" class="popup-cancel" mat-button>{{ popupInfo().cancel }}</button>
      @switch (data.type) {
        @case ('delete') {
          <button (click)="close(true)" class="popup-delete" mat-button>{{ popupInfo().delete }}</button>
        }
        @case ('subscribe') {
          <button (click)="close(true)" class="popup-subscribe" mat-button>{{ popupInfo().subscribe }}</button>
        }
        @case ('unsubscribe') {
          <button (click)="close(true)" class="popup-unsubscribe" mat-button>{{ popupInfo().unsubscribe }}</button>
        }
        @case ('reset') {
          <button (click)="close(true)" class="popup-reset" mat-button>{{ popupInfo().reset }}</button>
        }
        @case ('info') {
          <button (click)="close(true)" class="popup-info" mat-button>{{ popupInfo().confirm }}</button>
        }
        @case ('confirm') {
          <button (click)="close(true)" class="popup-confirm" mat-button>{{ popupInfo().confirm }}</button>
        }
      }
    }
  </div>
</div>
